import { FormFeedBack, PageWrapper, removeCpfMask } from '@repo/ui';
import { CpfInput } from 'adasi_components';
import { useFormik } from 'formik';
import { Card, Form, Label } from 'reactstrap';
import * as Yup from 'yup';

import { usePreRegistration } from '../../hooks/usePreRegistration';

const PreRegistration = () => {
  //Hooks
  const { handleCheckProfessionalExists } = usePreRegistration();

  //validation
  const validation = useFormik({
    initialValues: {
      cpf: '',
    },
    validationSchema: Yup.object().shape({
      cpf: Yup.string().required('CPF é obrigatório').cpfType('CPF é inválido'),
    }),
    onSubmit: () => {
      handleCheckProfessionalExists({
        cpf: removeCpfMask(validation.values.cpf),
      });
    },
  });

  return (
    <PageWrapper title={'Vincular profissional'}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>{'Vincular profissional'}</h4>
      </div>
      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <Card className="p-3">
          <div>
            <Label htmlFor="cpf" className="form-label">
              CPF
            </Label>
            <div className="d-flex flex-wrap gap-4">
              <CpfInput
                name="cpf"
                tabIndex={1}
                inputId="cpf"
                placeholder="CPF"
                className="form-control"
                value={validation.values.cpf}
                onBlur={validation.handleBlur}
                handleChange={validation.handleChange}
                invalid={!!(validation.touched.cpf && validation.errors.cpf)}
                style={{ width: '300px' }}
              />
              <button
                type="submit"
                className="btn btn-primary waves-effect waves-light d-flex align-items-center"
              >
                Verificar
              </button>
            </div>
            <FormFeedBack
              error={validation.errors?.cpf}
              isInvalid={!!(validation.touched && validation.errors?.cpf)}
            />
          </div>
        </Card>
      </Form>
    </PageWrapper>
  );
};

export default PreRegistration;
